/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./NftMallItem.vue?vue&type=template&id=622621e6&scoped=true"
import script from "./NftMallItem.vue?vue&type=script&lang=js"
export * from "./NftMallItem.vue?vue&type=script&lang=js"
import style0 from "./NftMallItem.vue?vue&type=style&index=0&id=622621e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622621e6",
  null
  
)

export default component.exports